import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CommonModule as NimbusCommonModule } from '../common/common.module';
import { DialogModule } from '../dialog';

import { LoginDialogComponent } from './login-dialog.component';
import { NimbusAuthComponent } from './nimbus-auth.component';

@NgModule({
  imports: [
    CommonModule,
    NimbusCommonModule,
    DialogModule
  ],
  exports: [
    LoginDialogComponent,
    NimbusAuthComponent
  ],
  declarations: [
    LoginDialogComponent,
    NimbusAuthComponent
  ],
  providers: [],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class LoginModule { }

export * from './login.actions';
